import React, { useEffect, useState, useCallback } from "react";
import Frame from "react-frame-component";
import parse from "html-react-parser";
import SizeSelector from "../utils/size-selector";
import Loading from "../../app/loading";
import "./banner.css";

const Banner = ({ banner, template, style, selectors, cleanTags, user }) => {
  const [html, setHtml] = useState();
  const [css, setCss] = useState();
  const [extraStyles, setExtraStyles] = useState();

  const transformCode = useCallback(
    async (code, set, flag) => {
      let obj = banner.fields;
      await Object.keys(obj).forEach((key) => {
        let str = `%${key}%`;
        if (typeof obj[key] !== "string") {
          let path = obj[key].path;
          if (code) code = code.replace(new RegExp(str, "g"), path);
        } else {
          let txt = obj[key];
          if (code) code = code.replace(new RegExp(str, "g"), txt);
        }
      });
      if (banner && code) {
        code = code.replace(
          "%%CLICK_URL_UNESC%%%%DEST_URL%%",
          banner.bannerURL
        );
        const clkEsc = /%%CLICK_URL_ESC%%/g;
        const urlEsc = /%%VIEW_URL_UNESC%%/g;
        code = code.replace(clkEsc, "").replace(urlEsc, "");
        //console.log("banner & code", code);
        if (flag) {
          code = code.replace(/<script>(.|\n)*?<\/script>/g, "");
          //console.log("flag 1", code);
          code = code.replace(/%2F/g, "###");
          //console.log("flag 2", code);
          //code = code.replace(/%(.*?)%/g, "");
          //console.log("flag 3", code);
          code = code.replace(/###/g, "%2F");
          //console.log("flag 4", code);
        }
      }
      set(code);
    },
    [banner]
  );

  useEffect(() => {
    if (banner.fields) {
      transformCode(template, setHtml, cleanTags);
    }
  }, [template, transformCode, banner.fields, cleanTags]);

  useEffect(() => {
    if (style && banner.fields) {
      transformCode(style, setCss);
    }
  }, [style, transformCode, banner.fields]);

  useEffect(() => {
    let status = "preview",
      fieldVariant = "",
      imagePresent = "empty";
    if (user && banner.currentUser) {
      let person = `${user.displayName} (${user.organisation})`;
      if (person === banner.currentUser) status = "edit";
    }
    if (banner.fields) {
      if (banner.fields.style) fieldVariant = ` ${banner.fields.style}`;
      if (banner.fields.SplashBanner) {
        if (banner.fields.SplashBanner.path) imagePresent = "filled";
      }
    }
    let style = `${banner.bannerType}${fieldVariant} ${status} ${imagePresent}`;
    setExtraStyles(style);
  }, [banner, user]);

  if (!html || !css) return <Loading />;

  return (
    <SizeSelector selectors={selectors}>
      <div className={`${extraStyles}`}>
        <Frame
          initialContent={`<!DOCTYPE html><html><head><style>${css}</style></head><body><div id="bannerFrame"></div></body></html>`}
          mountTarget="#bannerFrame"
        >
          <>{parse(html)}</>
        </Frame>
      </div>
    </SizeSelector>
  );
};

export default Banner;
